<template>
  <!-- 鱼计划 -->
  <div class="yujihua">
    <PublicCert :logo="Logo1" :type="'acet'" :color="'#f08608'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo1 from '@/assets/images/logo1.png'

export default {
  name: 'YuJiHua',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo1
    }
  }
}
</script>
